module.exports = __webpack_public_path__ + "static/media/wmsui32_3926.2bf4e8ab.ico";